import React from 'react';

import { get } from 'lodash';

import FormContainer from '../../../../FormContainer';
import Alert from '../../../../../Alert';

import useCheckInfoForm from '../../../../../../forms/billPayments/checkInfo';
import useVendorDirectInfoForm from '../../../../../../forms/billPayments/vendorDirectInfo';

const checkValueNames = [
  'check_disbursement_data.check_number',
  'check_disbursement_data.check_date',
  'check_disbursement_data.arrives_by_date',
  'check_disbursement_data.cleared_date',
  'check_disbursement_data.amount',
  'check_disbursement_data.memo',
  'check_disbursement_data.expiration_date',
  'check_disbursement_data.tracking_info',
  'check_disbursement_data.delivery_type_actual',
  'check_disbursement_data.returned_date',
  'check_disbursement_data.payee_address',
  'check_disbursement_data.error_code',
];

const vendorDirectValueNames = [
  'vendor_direct_disbursement_data.status',
  'vendor_direct_disbursement_data.masked_card_number',
  'vendor_direct_disbursement_data.settlement_date',
  'vendor_direct_disbursement_data.arrives_by_date',
  'vendor_direct_disbursement_data.vcard_account_number',
  'vendor_direct_disbursement_data.remit_email',
  'vendor_direct_disbursement_data.payment_type',
  'vendor_direct_disbursement_data.disbursement_status',
  'vendor_direct_disbursement_data.vcard_reissue_reason',
  'vendor_direct_disbursement_data.combined_status',
  'vendor_direct_disbursement_data.vendor_name',
];

export default function CheckInfo({ billPayment }) {
  const checkForm = useCheckInfoForm(() => {}, billPayment);
  const vendorDirectForm = useVendorDirectInfoForm(() => {}, billPayment);

  const hasCheckValue = checkValueNames.some(
    (valueName) => !!get(billPayment, valueName)
  );
  const hasVendorDirectValue = vendorDirectValueNames.some(
    (valueName) => !!get(billPayment, valueName)
  );

  if (!hasCheckValue && !hasVendorDirectValue) {
    return null;
  }

  return (
    <div>
      {billPayment?.vendor_direct_disbursement_data?.is_vendor_direct_vcard && (
        <div className="mb-4">
          <Alert message="This bill payment was sent to the vendor through the Bill.com vendor network." />
        </div>
      )}
      <FormContainer
        form={hasVendorDirectValue ? vendorDirectForm : checkForm}
        noSubmit
        noBillComId
      />
    </div>
  );
}
